import {sprintf} from 'sprintf-js';
import FEE_ROLLUP from './feerollup_states';

function totalSeats (activeSeats, GASeats) {
  const numSingleSeats = Object.keys(activeSeats).length;
  const numGASeats  = Object.keys(GASeats).length;
  return numSingleSeats + numGASeats;
}

function setShowUNOC(seats, seatIds, freeUnocId, showUNOC) {
  for (let i = 0; i < seatIds.length; i++) {
    const seatId = seatIds[i];
    if (+seats[seatId].priceType !== +freeUnocId) {
      showUNOC = true;
      return showUNOC;
    }
  }
  return showUNOC;
}

export function normalizeGAPrices (GASeats) {
  if (!GASeats) {
    return [];
  }

  const sections = Object.keys(GASeats);
  let i;
  let gaPrices = [];

  for (i = 0; i < sections.length; i++) {
    let section = sections[i];
    let categories = Object.keys(GASeats[section]);
    let j;
    for (j = 0; j < categories.length; j++) {
      let category = categories[j];
      let priceTypes = Object.keys(GASeats[section][category]);
      let k;
      for (k = 0; k < priceTypes.length; k++) {
        let price = {
          priceTypeId: parseInt(priceTypes[k], 10),
          qty: GASeats[section][category][priceTypes[k]].qty
        };

        gaPrices.push(price);
      }
    }
  }

  return gaPrices;
}

export function normalizeActiveSeatsPrices (activeSeats) {
  if (!activeSeats) {
    return [];
  }

  const seatsIds = Object.keys(activeSeats);
  let asPrices = [];

  for (let i = 0; i < seatsIds.length; i++) {
    let seatId = seatsIds[i];
    asPrices.push({
      priceTypeId: parseInt(activeSeats[seatId].priceType, 10),
      qty: 1
    });
  }

  return asPrices;
}

export function normalizePrices (activeSeats, GASeats) {
  return normalizeGAPrices(GASeats).concat(normalizeActiveSeatsPrices(activeSeats));
}

export function totalPlusMandatoryUpsells (activeSeats, GASeats, total, mandatoryUpsells) {
  if (!mandatoryUpsells) {
    return total;
  }

  let newTotal = total;
  const prices = normalizePrices(activeSeats, GASeats);

  mandatoryUpsells.forEach(mu => {
    for (let i = 0; i < prices.length; i++) {
      const price = prices[i];

      if (mu.applicableToPriceTypeIds.indexOf(price.priceTypeId) > -1) {

        newTotal += mu.minPrice * price.qty;
      }
    }
  });

  return newTotal;
}

export function totalBasket (props) {
  const {activeSeats, GASeats, total, mandatoryUpsells = 0} = props;
  return totalPlusMandatoryUpsells(activeSeats, GASeats, total, mandatoryUpsells);
}

export function showUNOC (props) {
  const {activeSeats, GASeats, priceTypes} = props;
  const typesSeatsIds = Object.keys(priceTypes);
  const activeSeatsIds = Object.keys(activeSeats);
  const GASeatIds = Object.keys(GASeats);

  let freeUnocId;
  if (!freeUnocId) {
    for (let i = 0; i < typesSeatsIds.length; i++) {
      let typeId = typesSeatsIds[i];
      if (priceTypes[typeId].code === 'FREE') {
        freeUnocId = priceTypes[typeId].number;
        break;
      }
    }
  }

  let showUNOC = false;
  const setUNOCForSelectedSeats = setShowUNOC(activeSeats, activeSeatsIds, freeUnocId, showUNOC);
  const showUNOCForGeneralAvailability = setShowUNOC(GASeats, GASeatIds, freeUnocId, showUNOC);

  return setUNOCForSelectedSeats || showUNOCForGeneralAvailability;
}


export function ticketPriceTotal (props) {
  const {activeSeats, GASeats, total, mandatoryUpsells, moneyFormat, currency, unocFeeTotal = 0} = props;
  const numTotalSeats = totalSeats(activeSeats, GASeats);
  if (numTotalSeats) {
    const totalPlus = (totalBasket(props) && showUNOC(props))
      ? totalPlusMandatoryUpsells(activeSeats, GASeats, total, mandatoryUpsells) + unocFeeTotal
      : totalPlusMandatoryUpsells(activeSeats, GASeats, total, mandatoryUpsells);
    const newTotal = totalPlus / 100;
    const decimals = Math.round((newTotal % 1) * 100);
    return sprintf(moneyFormat, newTotal, decimals, currency);
  }
  else {
    return 'Select seats from map';
  }
}

export function ticketFeeString (totalFees, text, moneyFormat) {
  if (totalFees === 0) {
    return '';
  }
  else {
    const total = totalFees / 100;
    const decimals = Math.round((total % 1) * 100);
    return sprintf(moneyFormat, total, decimals, text.currency);
  }
};

export function ticketFeeSum (prices, activeSeats) {
  return (
    Object.keys(activeSeats)
      .map(key => {
        const seat = activeSeats[key];
        const matchingPrices = prices.filter(price =>
          price.priceType === seat.priceType && price.priceCategory === seat.priceCategory
        );
        return (matchingPrices.length > 0) ? matchingPrices[0].includedCharge : 0;
      })
      .reduce((acc, val) => acc + val, 0)
  );
};

export function addNameAndValueOfMandatoryUpsellsToFeeMessage (feeMessage, props, text) {

  // If not opt 3, return feeMessage previously generated, ...
  if (props.feeRollup !== FEE_ROLLUP.ROLLUP_SHOW_BREAKDOWN) {
    return feeMessage;
  }
  else {
    // ... else concatenate feeMessage with mandatory upsells
    return rollupShowBreakdownCase(feeMessage, props, text);
  }
}

export function rollupShowBreakdownCase (feeMessage, props, text) {
  const {activeSeats, GASeats, mandatoryUpsells, moneyFormat, currency} = props;
  let mandatoryUpsellsMessage = [];

  const prices = normalizePrices(activeSeats, GASeats);
  let message = feeMessage;

  if (message[message.length - 1] === '.') {
    message = message.substring(0, message.length - 1);
  }

  // New obj o  is made so we can accumulate values for specific mandatory upsell name
  let o = {};
  mandatoryUpsells && mandatoryUpsells.forEach(mu => {
    let qty = 0;
    for (let i = 0; i < prices.length; i++) {
      const price = prices[i];
      const muName = mu.name;

      if (mu.applicableToPriceTypeIds.indexOf(price.priceTypeId) > -1) {
        qty += price.qty;
        o[muName] = mu.minPrice === 0 ? mu.minPriceFormatted : (mu.minPrice * qty);
      }
    }
  });
  for (const i in o) {
    let amount = '';
    // check if upsell  min price is number
    if (isNaN(o[i])) {
      amount = o[i];
    }
    else {
      const newTotal = o[i] / 100;
      const decimals = Math.round((newTotal % 1) * 100);
      amount =  sprintf(moneyFormat, newTotal, decimals, currency);
    }

    mandatoryUpsellsMessage.push(`${amount} ${i}`);
  }

  let sum = [message, ...mandatoryUpsellsMessage];
  const mandatoryUpsellsMessageLength = mandatoryUpsellsMessage.length;

  if (message === '' && mandatoryUpsellsMessageLength === 0) {
    return '';
  }
  if (message === '' && mandatoryUpsellsMessageLength === 1) {
    return `${text.serviceFeePrefix} ${mandatoryUpsellsMessage[0]}`;
  }
  if (message === '' && mandatoryUpsellsMessageLength > 1) {
    let last = mandatoryUpsellsMessage.pop();
    let s = mandatoryUpsellsMessage.join(', ');
    return `${text.serviceFeePrefix} ${s} ${text.and} ${last}`;
  }
  //
  if (message !== '' && mandatoryUpsellsMessageLength === 0) {
    return message;
  }
  if (message !== '' && mandatoryUpsellsMessageLength === 1) {
    let last = sum.pop();
    let s = sum.join(', ');
    return `${s} ${text.and} ${last}`;
  }
  if (message !== '' && mandatoryUpsellsMessageLength > 1) {
    let last = sum.pop();
    let s = sum.join(', ');
    return `${s} ${text.and} ${last}`;
  }
}

export function normalizeGASeats (GASeats) {
  if (!GASeats) {
    return [];
  }
  const sections = Object.keys(GASeats);
  let i;
  let gaSeatsFormated = [];
  for (i = 0; i < sections.length; i++) {
    const section = sections[i];
    const categories = Object.keys(GASeats[section]);
    let j;
    for (j = 0; j < categories.length; j++) {
      let category = categories[j];
      let priceTypes = Object.keys(GASeats[section][category]);
      for (let k = 0; k < priceTypes.length; k++) {
        let seat = {
          priceCategoryId : GASeats[section][category][priceTypes[k]].priceCategoryId,
          priceType: GASeats[section][category][priceTypes[k]].price.priceType,
          qty: GASeats[section][category][priceTypes[k]].qty
        };
        gaSeatsFormated.push(seat);
      }
    }
  }
  return gaSeatsFormated;
}

export function ticketFeeSumForActiveAndGaSeats (prices, activeSeats, GASeats) {
  const gaSeatsFormated = normalizeGASeats(GASeats);
  const activeSeatsCharges = ticketFeeSum(prices, activeSeats);
  const gaSeatsFormatedCharges = gaSeatsFormated.map(seat => {
    const matchingPrices = prices.filter(price =>
      price.priceType === seat.priceType && price.priceCategory === seat.priceCategoryId
    );
    return (matchingPrices.length > 0) ? matchingPrices[0].includedCharge * seat.qty : 0;
  }).reduce((acc, val) => acc + val, 0);
  return gaSeatsFormatedCharges + activeSeatsCharges;
};



// WEBPACK FOOTER //
// ./frontend/react/components/edp/basket/recap/utils.js